var _class, _DropdownComponent, _isUpdatingSelected, _isInitialized, _execute, _unescapeValue, _getValue;
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from '@ember/object';
import { hash, concat } from '@ember/helper';
import Component from '@glimmer/component';
import { WithBoundArgs } from '@glint/template';
import { modifier } from 'ember-modifier';
import $ from 'jquery';
import DropdownDivider from './dropdown/divider';
import DropdownItem from './dropdown/item';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
/**
 * This component manages two types of data depending of the simple selection or
 * the multiple selection.
 *
 * - A single selection manage a string
 * - A multiple selection manage an array of strings.
 *
 * It can be used as a classic component with an
 * `onChange` callback and a `selected` attribute.
 */
let DropdownComponent = (_class = (_isUpdatingSelected = /*#__PURE__*/new WeakMap(), _isInitialized = /*#__PURE__*/new WeakMap(), _execute = /*#__PURE__*/new WeakMap(), _unescapeValue = /*#__PURE__*/new WeakMap(), _getValue = /*#__PURE__*/new WeakMap(), _DropdownComponent = class DropdownComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "dropdownElement", null);
    _classPrivateFieldInitSpec(this, _isUpdatingSelected, false);
    _classPrivateFieldInitSpec(this, _isInitialized, false);
    _defineProperty(this, "updateDropdownModifier", modifier(element1 => {
      if (!_classPrivateFieldGet(_isInitialized, this)) {
        this._setupDropdown(element1);
      } else {
        this._updateSelected();
      }
    }));
    _classPrivateFieldInitSpec(this, _execute, (command1, ...args1) => {
      return (
        // prettier-ignore
        // eslint-disable-next-line ember/no-jquery
        $(this.dropdownElement).dropdown(command1, ...args1)
      );
    });
    /**
    * Replace HTML escaped characters.
    *
    * Fomantic-UI relies on jQuery for getting content of items in the dropdown.
    * If the dropdown contains an item with an apostrophe, the way jQuery gets
    * the data (with jQuery.data) makes the content been escaped for some characters.
    *
    * This is especially true with the apostrophe which is escaped with `&#x27;`.
    *
    * This code transforms this sequence in an apostrophe.
    *
    * Example of received text: "L&#x27;acomorb". Will be transformed to "L'acomorb".
    *
    */
    _classPrivateFieldInitSpec(this, _unescapeValue, value1 => {
      // eslint-disable-next-line ember/no-jquery
      return $(`<div>${value1}</div>`).text();
    });
    _classPrivateFieldInitSpec(this, _getValue, () => {
      if (_classPrivateFieldGet(_execute, this).call(this, 'is multiple')) {
        // This step is necessary when working with a multiple dropdown because multiple values
        // is represented as a unique string.
        // We thus get the values from Fomantic UI, which will return an array if there is an item,
        // or an empty string if no value is set.
        const values1 = _classPrivateFieldGet(_execute, this).call(this, 'get values') || [];
        return values1.map(item1 => _classPrivateFieldGet(_unescapeValue, this).call(this, item1));
      }
      const value1 = _classPrivateFieldGet(_execute, this).call(this, 'get value');
      return _classPrivateFieldGet(_unescapeValue, this).call(this, value1);
    });
  }
  _setupDropdown(element1) {
    this.dropdownElement = element1;
    // eslint-disable-next-line ember/no-jquery
    $(element1).dropdown({
      onChange: this.onChange.bind(this),
      onSearch: this.args.onSearch?.bind(this),
      fullTextSearch: true,
      ignoreDiacritics: this.args.ignoreDiacritics,
      forceSelection: false,
      hideDividers: 'empty',
      allowAdditions: this.args.allowAdditions,
      hideAdditions: false,
      className: {
        addition: 'stuck addition'
      },
      message: {
        addResult: 'Ajouter <b>{term}</b>',
        noResults: this.args.noResultsText || 'Aucun résultat.'
      }
    });
    _classPrivateFieldSet(_isInitialized, this, true);
    this._updateSelected();
  }
  /**
  * Set the selected value of the dropdown.
  */
  _updateSelected() {
    _classPrivateFieldSet(_isUpdatingSelected, this, true);
    /**
    * This method will call the onChange callback.
    * So modifying the `selected` property from outside will call
    * the callback.
    * That's why we use the '#isUpdatingSelected' to prevent an inifinite loop
    */ // @ts-expect-error The type of second argument of this.#execute should be Array of string
    _classPrivateFieldGet(_execute, this).call(this, 'set exactly', this.args.selected);
    _classPrivateFieldSet(_isUpdatingSelected, this, false);
  }
  get placeholder() {
    return this.args.placeholder ?? 'Sélectionnez ou tapez votre texte';
  }
  onChange() {
    // This check avoid to call the 'onChange' callback after an
    // explicit set on the '@selected'.
    if (!_classPrivateFieldGet(_isUpdatingSelected, this)) {
      this.args.onChange?.(_classPrivateFieldGet(_getValue, this).call(this));
    }
  }
}, setComponentTemplate(precompileTemplate("\n    {{#if @labelName}}\n      <label>\n        {{@labelName}}{{if @isMandatory \" *\"}}\n      </label>\n    {{/if}}\n\n    <div class={{concat \"ui selection\" (if @clearable \" clearable\" \" search\") (if @multipleSelection \" multiple\") (if @isReadOnly \" disabled semeia-readonly\") (if @size (concat \" \" @size) \" fluid\") \" dropdown\"}} data-test-dropdown={{@propertyName}} ...attributes {{this.updateDropdownModifier}}>\n      <div class=\"default text\" data-test-select-placeholder>\n        {{this.placeholder}}\n      </div>\n      {{#unless @isReadOnly}}\n        <i class=\"dropdown icon\"></i>\n      {{/unless}}\n\n      <div class=\"menu\">\n        {{yield (hash Item=(component DropdownItem translationKey=@translationKey unfilterable=@unfilterable) Divider=DropdownDivider)}}\n      </div>\n    </div>\n  ", {
  strictMode: true,
  scope: () => ({
    concat,
    hash,
    DropdownItem,
    DropdownDivider
  })
}), _DropdownComponent), _DropdownComponent), _applyDecoratedDescriptor(_class.prototype, "_setupDropdown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_setupDropdown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_updateSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_updateSelected"), _class.prototype), _class);
export { DropdownComponent as default };